<template>
  <div class="gather-control">
    <el-form :model="control" label-width="70px">
      <el-form-item prop="name">
        <template slot="label">
          <span class="require-flag">*</span>
          名称
        </template>
        <el-input v-model="control.name"></el-input>
      </el-form-item>
      <el-form-item prop="sourceCid">
        <template slot="label">
          <span class="require-flag">*</span>
          关联表
        </template>
        <div class="sourceCidContainer">
          <el-select v-model="control.sourceCid" placeholder="请选择">
            <el-option
              v-for="item in gatherOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item prop="gatherCid">
        <template slot="label">
          <span class="require-flag">*</span>
          汇总字段
        </template>
        <div class="gatherCidContainer">
          <el-select v-model="control.gatherCid" placeholder="请选择">
            <el-option
              v-for="item in gatherControlOptions"
              :key="item._cid"
              :label="item.name"
              :value="item._cid"
            ></el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item prop="gatherType">
        <template slot="label">
          <span class="require-flag">*</span>
          汇总类型
        </template>
        <div class="gatherTypeContainer">
          <el-select v-model="control.gatherType" placeholder="请选择">
            <el-option
              v-for="item in gatherTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item prop="gatherFilters">
        <template slot="label">
          汇总筛选
        </template>
        <el-button type="text" @click="gatherFilterVisible = true">设置筛选条件</el-button>
      </el-form-item>
      <el-form-item prop="unit">
        <template slot="label">
          单位
        </template>
        <el-input v-model="control.unit"></el-input>
      </el-form-item>
      <el-form-item prop="decimal">
        <template slot="label">
          小数
        </template>
        <el-input-number
          v-model="control.decimal"
          :step="1"
          :min="0"
          :max="10"
          size="small"
        ></el-input-number>
      </el-form-item>
      <el-form-item prop="description">
        <template slot="label">
          描述
        </template>
        <el-input v-model="control.description"></el-input>
      </el-form-item>
      <el-form-item prop="required">
        <template slot="label">
          必填
        </template>
        <el-checkbox v-model="control.required" :disabled="control.main"></el-checkbox>
      </el-form-item>
      <el-form-item prop="display">
        <template slot="label">
          显示
        </template>
        <el-checkbox v-model="control.display" :disabled="control.main"></el-checkbox>
      </el-form-item>
      <el-form-item prop="disabled">
        <template slot="label">
          不可编辑
        </template>
        <el-checkbox v-model="control.disabled"></el-checkbox>
      </el-form-item>
      <el-form-item prop="main">
        <template slot="label">
          标题
        </template>
        <el-checkbox v-model="control.main" @change="checkChange($event)"></el-checkbox>
      </el-form-item>
    </el-form>
    <sheet-filter
      ref="gatherFilter"
      :condition-list="oldControl['gatherFilters']"
      @submit="setGatherFilter"
      :dialog-visible.sync="gatherFilterVisible"
      :search-sheet="gatherFilterSheet"
    ></sheet-filter>
  </div>
</template>

<script>
import SheetFilter from "@/components/UIComponents/SheetFilter"
import { decorateSheet } from "@/utils/sheet"
export default {
  name: "gather-control",
  components: {
    SheetFilter
  },
  props: {
    control: Object,
    sheet: {
      type: Object
    },
    availableSheetMap: {
      type: Object
    },
    fields: Array,
    oldControl: Object
  },
  data() {
    return {
      gatherFilterVisible: false
    }
  },
  computed: {
    gatherOptions() {
      let opt = []
      this.fields.forEach(c => {
        let refSheet = decorateSheet(this.availableSheetMap[c.refSheetId])
        if (c._type === "ref" && !c.oneFlag && refSheet) {
          opt.push({
            label: c.name,
            value: c._cid,
            controls: refSheet.controls
          })
        }
      })
      return opt
    },
    gatherControlOptions() {
      if (!this.control?.sourceCid) return []
      let source = this.gatherOptions.find(opt => opt.value === this.control.sourceCid) || {}
      let special = [{ _cid: "*", name: "记录数量" }]
      let common = source.controls || []
      let all = special.concat(common)
      if (!all.find(opt => opt._cid === this.control.gatherCid)) {
        this.control.gatherCid = null
      }
      return all
    },
    gatherTypeOptions() {
      if (this.control._type !== "gather") return []
      let control = this.gatherControlOptions.find(opt => opt._cid === this.control.gatherCid) || {}
      if (!control._cid && Object.prototype.hasOwnProperty.call(this.control, "gatherType")) {
        this.control.gatherType = null
        return []
      }
      let res = []
      if (control._cid === "*") {
        res = [{ label: "计数", value: "COUNT" }]
      } else if (control._dataType === "number" || control._type === "calc") {
        res = [
          { label: "已填", value: "FILL" },
          { label: "未填", value: "NOT_FILL" },
          { label: "求和", value: "SUM" },
          { label: "平均", value: "AVG" },
          { label: "最大", value: "MAX" },
          { label: "最小", value: "MIN" }
        ]
      } else {
        res = [
          { label: "已填", value: "FILL" },
          { label: "未填", value: "NOT_FILL" }
        ]
      }
      if (!res.find(r => r.value === this.control.gatherType)) {
        this.control.gatherType = res[0].value
      }
      return res
    },
    gatherFilterSheet() {
      let sourceCid = this.control?.sourceCid
      if (!sourceCid) return {}
      let refControl = this.fields.find(c => c._cid === sourceCid || c.code === sourceCid) || {}
      return this.availableSheetMap[refControl.refSheetId] || {}
    }
  },
  methods: {
    checkChange(value) {
      this.$emit("checkboxChange", "main", value)
    },
    setGatherFilter(condition) {
      this.control["gatherFilters"] = condition
    }
  }
}
</script>

<style lang="scss" scoped>
.gather-control {
  .el-form {
    padding: 12px 12px 0 0;
  }
}
</style>
